//
import { Model as BaseModel } from 'vue-api-query'

/**
 * @model Model
 */
export default class Model extends BaseModel {

    //
    static appends  = []
    static errors   = {}
    static filters  = []
    static forms    = {}
    static headers  = []
    static includes = []

    //
    get __base_url() {
        return this.baseURL().split('/').filter(Boolean).join('/')
    }
    
    /**
     * define a base url for a REST API
     */
    baseURL () {
        return process.env.VUE_APP_API_ROUTE
    }

    /**
     * 
     */
    clean ( props = [] ) {

        //
        var clone = this.clone()

        //
        Object.keys( clone ).forEach( key => {
            if ( !props.some( prop => prop === key ) ) {
                delete clone[ key ]
            }            
        })

        //
        return clone
    }

    /**
     * 
     */
    clone () {
        return Object.assign( Object.create( Object.getPrototypeOf(this)), this)
    }

    /**
     * Fetches a blob.
     *
     * @param      {string}  [path='']  The path
     * @return     {<type>}  The blob.
     */
    fetchBlob(path = '') {
        return this.request({
            responseType: 'blob',
            method: 'GET',
            url: this.fullURL().concat('/').concat(path),
        })
    }

    static from(data = {}) {
        return new this(data)
    }

    /**
     * 
     */
    static async fetchDataTable ( limit, page, sort, params = {} ) {

        //
        try {

            //
            return ( await this.modeler().limit( limit ).page( page ).orderBy( sort ).params( params ).get() )
        } catch ( error ) {

            //
            //console.error( error )
            
            //
            return []
        }
    }

    /**
     * get the full url for the current model
     */
    fullURL () {
        return [ this.baseURL(), this.resource(), this.id ].join("/")
    }

    /**
     * @description
     * Gets the property.
     *
     * @param      {<type>}  path    The path
     * @return     {<type>}  The property.
     */
    getProperty(path, prevent) {
        return path.split('.').reduce(this.reduceHasProperty, this) || prevent
    }

    /**
     * 
     */
    static modeler () {
        return this.append( this.appends ).include( this.includes )
    }

    /**
     * Reduces the has property.
     *
     * @param      {<type>}  parent    The parent
     * @param      {<type>}  property  The property
     * @param      {<type>}  index     The index
     * @return     {<type>}  { description_of_the_return_value }
     */
    reduceHasProperty(parent, property) {
        return typeof parent === "object" && parent !== null ? parent[property] : undefined
    }

    /**
     * 
     */
    replace (data) {
        return this.$http.request({
            method: "patch",
            url: this.fullURL(),
            data
        })
    }
    
    /**
     * implement a default request method 
     * 
     * @param {*} config 
     */
    request (config) {
        return this.$http.request(config)
    }

    /**
     * 
     */
    reset () {
        return this
    }

    /**
     *
     */
    showFile = (filename, fileExtend) => res => {
        //
        var fileLink = document.createElement('a')
        var fileURL = URL.createObjectURL(res.data)
        //
        fileLink.href = fileURL
        fileLink.download = filename.concat('.').concat(fileExtend)
        //file
        //console.log(fileURL)
        //fileURL.setAttribute('download', filename)

        //window.open(fileURL)
        fileLink.click()
    }

    /**
     * 
     */
    toDelete () {
        return this.clean([
            "id",
        ])
    }

    /**
     * 
     */
    usage(path) {
        return this.__base_url.concat('/').concat(path)
    }
}